import videojs from 'video.js';

// Get the required components
const MenuButton = videojs.getComponent('MenuButton');
const Menu = videojs.getComponent('Menu');
const MenuItem = videojs.getComponent('MenuItem');

class CustomDropdown extends MenuButton {
  constructor(player, options) {
    super(player, options);
    this.addClass('vjs-custom-dropdown');
    // this.controlText('Custom Dropdown');
  }

  createEl() {
    const el = super.createEl('div', {
      className: 'vjs-menu-button vjs-menu-button-popup vjs-control vjs-button vjs-custom-dropdown',
    });

    // Create the button element
    const button = videojs.dom.createEl('button', {
      className: 'vjs-menu-button vjs-menu-button-popup vjs-button',
      type: 'button',
      'aria-disabled': 'false',
      'aria-haspopup': 'true',
      'aria-expanded': 'false', // Toggle this attribute to reflect menu state
    });

    // Create the icon placeholder (SVG)
    const iconPlaceholder = videojs.dom.createEl('span', {
      className: 'vjs-icon-placeholder vjs-svg-icon',
      innerHTML: `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
      </svg>
      `,
    });

    // Create the control text
    const controlText = videojs.dom.createEl('span', {
      className: 'vjs-control-text',
      innerHTML: 'Transcript',
      'aria-live': 'polite',
    });

    // Append elements to the button
    button.appendChild(iconPlaceholder);
    button.appendChild(controlText);

    // Append the button to the main element
    // el.appendChild(button);
    const firstChild = el.firstChild;
    el.insertBefore(button, firstChild); // Insert before the first child

    // Add click event listener to toggle the menu
    button.addEventListener('click', () => {
      if (!this.menu) {
        // If the menu is not yet created, create it
        this.menu = this.createMenu();
        this.player_.el().appendChild(this.menu.el());
      }

      // Toggle the visibility by adding/removing classes
      const isMenuVisible = this.menu.el().classList.contains('vjs-lock-showing');
      if (isMenuVisible) {
        this.menu.el().classList.remove('vjs-lock-showing');
        this.menu.el().classList.add('vjs-hidden');
        button.setAttribute('aria-expanded', 'false'); // Update aria-expanded
      } else {
        this.menu.el().classList.add('vjs-lock-showing');
        this.menu.el().classList.remove('vjs-hidden');
        button.setAttribute('aria-expanded', 'true'); // Update aria-expanded
      }
    });

    return el;
  }

  createMenu() {
    // Create the menu instance
    const menu = new Menu(this.player_, { menuButton: this });

    // Add menu items dynamically from options
    (this.options_.items || []).forEach((item) => {
      const menuItem = new MenuItem(this.player_, {
        label: item.label,
        selectable: true,
      });

      menuItem.on('click', () => {
        this.player_.trigger('dropdown:select', item.label);
      });

      menu.addItem(menuItem);
    });

    return menu;
  }
}

// Register the component
videojs.registerComponent('CustomDropdown', CustomDropdown);

// Add the custom dropdown to the player
videojs.registerPlugin('addCustomDropdown', function (options) {
  this.ready(() => {
    // const dropdown = this.controlBar.addChild('CustomDropdown', options);
    const dropdown = this.controlBar.addChild('CustomDropdown', options, this.controlBar.children().length - 11);

    dropdown.controlText('Transcript');
  });
});
